import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'

const ebCargo = ds.QEbCargo.using(dsc)
const mdCodeDict = ds.QMdCodeDict.using(dsc)

export const query = (params) => {
  ds[params.modelName].select()
}

// 通过ebOrderId+totalFlag查询
ebCargo.getEbCargoByEbOrderIdAndTotalFlag = function (searchData) {
  
  return ebCargo
    .selectOne(ebCargo.ebOrderId, ebCargo.field)
    .where(ebCargo.ebOrderId.eq$(searchData.ebOrderId).and(ebCargo.totalFlag.eq$(searchData.totalFlag)))
    .tag('getEbCargoByEbOrderIdAndTotalFlag')
    .execute()
}

// 通过ebOrderId查询
ebCargo.getEbCargoByEbOrderId= function (ebOrderId) {
  return ebCargo
    .select(ebCargo.fieldContainer())
    .where(ebCargo.ebOrderId.eq$(ebOrderId))
    .tag('getEbCargoByEbOrderId')
    .execute()
}


//这个是数据服务的写法，
// 通过ebOrderId查询
ebCargo.getCodo= function (params) { 

  return mdCodeDict
    .select(mdCodeDict.fieldContainer())
    
    // .select(mdCodeDict.isActive）//这个是单个的
    .where(params.whereObj)
    .tag('getMdCodeDict')
    .page(params.page,params.limit)
    .execute(params.valueObj)
}

export default ebCargo
